import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { PureComputed, Subscribable, SubscribableOrNullableValue } from 'knockout';
import { CurrentUserManager } from 'managers/currentUser';
import { IWCCStorageManager } from 'managers/iStorage';
import { Person } from 'models/person';
import { TopicThread } from 'models/topicThread';
import './settings.html';
import './settings.scss';

const { isStaging, discussionId } = settings;

export interface CommentSettingsVMConfig {
    comment: SubscribableOrNullableValue<TopicThread>
    visible: SubscribableOrNullableValue<boolean>
}

@injectable()
export default class CommentSettingsVM {
    private isModeratorUser: Subscribable<boolean>
    private isRegularComment: Subscribable<boolean>
    private isVisibleBySetting: Subscribable<boolean>

    comment: Subscribable<TopicThread | undefined>

    isReady: Subscribable<boolean>
    isResponseSettingShown: Subscribable<boolean>

    constructor(
        @inject(wccModules.componentConfig) config: CommentSettingsVMConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo,
        @inject(wccModules.storage) storage: IWCCStorageManager
    ) {
        this.comment = ko.flattenComputed(config.comment);

        this.isVisibleBySetting = ko.flattenComputed(config.visible, true);

        const participant = this.comment.mapNotNull(comment => Person.fromThread(comment));
        this.isRegularComment = participant.pluck(p => p.isRegular, false);

        const currentUserManager = storage.get(CurrentUserManager, { discussionId });
        const user = currentUserManager.pluck('person');
        this.isModeratorUser = user.pluck(u => u.isModerator, false);

        this.isResponseSettingShown = ko.pureComputed(() => this.checkIfShouldShowResponseSetting());

        this.isReady = this.isResponseSettingShown;

        ko.applyBindingsToNode(info.element, {
            'visible': this.isReady,

            'css': {
                'topic__comment__settings': true
            }
        });
    }

    private checkIfShouldShowResponseSetting() {
        return !isStaging &&
            this.isVisibleBySetting() &&
            this.isModeratorUser() &&
            this.isRegularComment();            
    } 
}